import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";
import { enqueueSnackbar } from "notistack";

const updateDiscountDetails = async (user, data,) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable
            ? localStorage.getItem("accessToken")
            : "";
        const config = {
            method: "put",
            maxBodyLength: Infinity,
            url: `/service/events_service/v1/events/discount-coupon/update`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,

            },
            data: data,

        };
        const response = await axios.request(config);
        return response;
    } catch (error) {
        if (error?.status === 401) {
            enqueueSnackbar("Un Authorized Request", {
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            });
            logout();
        }
        if (error?.data === "Verification timeout") {
            return;
        }
        enqueueSnackbar(error?.data?.message || error?.data, {
            variant: "error",
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
        });
    }
};

export default updateDiscountDetails;
